import { useState } from 'react';
import { Button, MenuItem, Select, SelectChangeEvent, Stack } from '@mui/material';
import { tasksApi } from './api';
import { TaskStatusEnum, TASK_STATUS_MAP } from 'shared/ui/formik-fields/task-status-picker-field';

type TasksTabActionsProps = {
  checkedItems: number[];
  onClearSelection: () => void;
  onOpenCreate: () => void;
};

export const TasksTabActions = ({ checkedItems, onClearSelection, onOpenCreate }: TasksTabActionsProps) => (
  <Stack direction="row" spacing={1} alignItems="center">
    <Button variant="contained" size="small" onClick={onOpenCreate}>
      Новая задача
    </Button>
    {checkedItems.length > 0 && <TasksBulkStatusDropdown selectedIds={checkedItems} onDone={onClearSelection} />}
  </Stack>
);

const TasksBulkStatusDropdown = ({ selectedIds, onDone }: { selectedIds: number[]; onDone: () => void }) => {
  const [value, setValue] = useState<number | ''>('');
  const [bulkUpdateStatus, { isLoading }] = tasksApi.useUpdateTasksStatusBulkMutation();

  const handleChange = async (event: SelectChangeEvent<number | ''>) => {
    const nextValue = event.target.value === '' ? '' : Number(event.target.value);
    setValue(nextValue);
    if (nextValue === '') return;

    try {
      await bulkUpdateStatus({ ids: selectedIds, status: nextValue }).unwrap();
      onDone();
    } finally {
      setValue('');
    }
  };

  return (
    <Select
      size="small"
      displayEmpty
      disabled={isLoading}
      value={value}
      onChange={handleChange}
      renderValue={(selected) => (selected ? TASK_STATUS_MAP[selected as number] : 'Изменить статус...')}
    >
      <MenuItem value="" disabled>
        Изменить статус...
      </MenuItem>
      {([TaskStatusEnum.NEW, TaskStatusEnum.IN_PROGRESS, TaskStatusEnum.COMPLETED, TaskStatusEnum.CLOSED] as const).map((status) => (
        <MenuItem key={status} value={status}>
          {TASK_STATUS_MAP[status]}
        </MenuItem>
      ))}
    </Select>
  );
};
